import { computed } from 'vue';

export const routerLinkProps = {
    custom: {
        type: Boolean,
        default: undefined,
        docs: {
            validation: '—',
            description:
                'Whether RouterLink should not wrap its content in an a tag. Useful when using v-slot to create a custom RouterLink. You can find more information about the `custom` prop on the [vue-router documentation](https://router.vuejs.org/api/interfaces/RouterLinkProps.html#Properties-custom).',
            support: ['routing'],
        },
    },
    linkTag: {
        type: String,
        default: 'router-link',
        validator(value) {
            return ['router-link', 'nuxt-link'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `router-link`, `nuxt-link`.',
            description: 'Configures if `nuxt-link` or `router-link` should be used.',
            support: ['routing'],
        },
    },
    noPrefetch: {
        type: Boolean,
        default: undefined,
        docs: {
            validation: '—',
            description: 'Disables the `prefetch` option on a link.',
            support: ['routing'],
        },
    },
    prefetch: {
        type: Boolean,
        default: undefined,
        docs: {
            validation: '—',
            description:
                'Configures the `prefetch` value on a link by overriding the default value of router.prefetchLinks configured in the nuxt.config.js configuration file.',
            support: ['routing'],
        },
    },
    replace: {
        type: Boolean,
        default: undefined,
        docs: {
            validation: '—',
            description:
                'Setting `replace` prop will call `router.replace()` instead of `router.push()` when clicked, so the navigation will not leave a history record. You can find more information about the `replace` prop on the [vue-router documentation](https://router.vuejs.org/api/interfaces/RouterLinkProps.html#Properties-replace).',
            support: ['routing'],
        },
    },
    to: {
        type: [String, Object],
        docs: {
            validation: '—',
            description:
                'Determines if a component is used for routing and denotes the target route of the link. You can find more information about the `to` prop on the [vue-router documentation](https://router.vuejs.org/api/interfaces/RouterLinkProps.html#Properties-to).',
            support: ['routing'],
        },
    },
};

export function useRouting(componentProps) {
    const isRouterActive = computed(() => {
        return componentProps.to !== null && componentProps.to !== undefined;
    });

    const routerLinkScope = computed(() => {
        const linkProps = Object.keys(routerLinkProps).filter(x => x !== 'linkTag');
        const linkPropsSet = {};
        for (const linkProp of linkProps) {
            if (componentProps[linkProp] !== undefined && componentProps[linkProp] !== null) {
                linkPropsSet[linkProp] = componentProps[linkProp];
            }
        }
        return isRouterActive.value
            ? {
                  ...linkPropsSet,
              }
            : null;
    });

    return {
        isRouterActive,
        routerLinkScope,
    };
}
